import { $qs , $qsa } from "./utils/querySelector"
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitText from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);

function preloader() {

    if($qs('body').classList.contains('page-template-home')) {
        const video = $qs("[data-target=scroll-video]");  
        // remove on scroll video
        video.pause();
        function iOS() {
            return [
              'iPad Simulator',
              'iPhone Simulator',
              'iPod Simulator',
              'iPad',
              'iPhone',
              'iPod'
            ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
          }

        if(iOS()) {
            // addon scroll video
            // video.setAttribute('autoplay', 'true');
        }
        // Video functions
        let src = video.currentSrc || video.src;        
    
        /* Make sure the video is 'activated' on iOS */
        function once(el, event, fn, opts) {
          var onceFn = function (e) {
            el.removeEventListener(event, onceFn);
            fn.apply(this, arguments);
          };
          el.addEventListener(event, onceFn, opts);
          return onceFn;
        }
        
        // once(document.documentElement, "touchstart", function (e) {
        //     // add on scroll video
        // // video.removeAttribute('autoplay')
        //     video.play();
        //     // video.pause();

        // });          
        window.onbeforeunload = function () {
            window.scrollTo(0, 0);
          }

        var pin = $qs('[data-target=js-preloader-pin]');
        var preloader = $qs('[data-target=js-preloader]');
        var preloaderTitle = $qs('[data-target=js-preloader-title]');
        new SplitText('.js-preloader-split', {type: "chars", charsClass: "preloader-title-chars"});
        var preloaderTitleFillers = $qsa('[data-target=js-overlay-title-fill]');
        var realTitle = $qs('[data-target=js-overlay-title]');
        var col1 = $qs('[data-target=js-preloader-col-1]');
        var col2 = $qs('[data-target=js-preloader-col-2]');
        var col3 = $qs('[data-target=js-preloader-col-3]');
        var col4 = $qs('[data-target=js-preloader-col-4]');
        var col5 = $qs('[data-target=js-preloader-col-5]');
        var title1 = $qs('[data-target=js-overlay-title-1]')
        var title2 = $qs('[data-target=js-overlay-title-2]')
        var title3 = $qs('[data-target=js-overlay-title-3]')
        var title4 = $qs('[data-target=js-overlay-title-4]')
        var menuHamburger = $qs('[data-target=menu-hamburger]');
        // var menuMenu = $qs('[data-target=js-preloader-menu-menu]');
        var menu = $qs('.js-preloader-menu');
        var menuLogo = $qs('[data-target=js-preloader-logo]');
        var menuMini = $qs('[data-target=js-preloader-mini-nav]');
        var content = $qs('.js-preloader-content ');
        var scrollTag = $qs('[data-target=js-preloader-scroll-tag]');
        var scrollLine = $qs('[data-target=js-preloader-scroll-line]');
        
        let introTitle = $qs("[data-target=scroll-video-intro-title]");
        let introText = $qs("[data-target=scroll-video-intro-text]");

        var placeholderScaled  = $qs('[data-target=js-preloader-scaled-placeholder]');
        var placeholderStatic = $qs('[data-target=js-preloader-static-placeholder]');

        gsap.set(placeholderStatic, {
            height: placeholderScaled.clientHeight,
            width: preloaderTitle.clientWidth
        })

                

        // Placeholder 1
        var placeholderTitle1 = $qs('[data-target=js-title-placeholder-1]');
        var placeholderTitle2 = $qs('[data-target=js-title-placeholder-2]');
        var placeholderTitle3 = $qs('[data-target=js-title-placeholder-3]');
        var placeholderTitle4 = $qs('[data-target=js-title-placeholder-4]');
        // Placeholder 2
        var placeholderTitle2_1 = $qs('[data-target=js-title-placeholder-2-1]');
        var placeholderTitle2_2 = $qs('[data-target=js-title-placeholder-2-2]');
        var placeholderTitle2_3 = $qs('[data-target=js-title-placeholder-2-3]');
        var placeholderTitle2_4 = $qs('[data-target=js-title-placeholder-2-4]');

        var preloaderTL = gsap.timeline({
            scrollTrigger: {
                start: 'top top',
                end: window.innerHeight * 4,
                trigger:  pin,
                scrub: 1.8,
                pin: true,                    
            }
        })

        var loadingTL = gsap.timeline({});

        loadingTL.to(title1, {
            position: 'absolute',
            top: placeholderTitle2_1.offsetTop,
            left: placeholderTitle2_1.offsetLeft,            
        })
        loadingTL.to(title2, {
            position: 'absolute',
            top: placeholderTitle2_2.offsetTop,
            left: placeholderTitle2_2.offsetLeft,  
        })
        loadingTL.to(title3, {
            position: 'absolute',
            top: placeholderTitle2_3.offsetTop,
            left: placeholderTitle2_3.offsetLeft,  
        })
        loadingTL.to(title4, {
            position: 'absolute',
            top: placeholderTitle2_4.offsetTop,
            left: placeholderTitle2_4.offsetLeft,                       
        })
        loadingTL.fromTo(col1, {
            y: window.innerHeight,
            opacity: 0,
        }, {
            opacity: 1,
            y: 0,
            ease: "power4.out",
            duration: 2,
        }, ">")
        loadingTL.fromTo(col2, {
            y: -1 * window.innerHeight,
            ease: "power4.out",
            duration: 2,
            opacity: 0,
        }, {
            opacity: 1,
            y: 0,
            ease: "power4.out",
            duration: 2,
        },  "<")
        loadingTL.fromTo(col3, {
            y: window.innerHeight,
            ease: "power4.out",
            duration: 2,
            opacity: 0,
        }, {
            opacity: 1,
            y: 0,
            ease: "power4.out",
            duration: 2,
        },  "<")
        loadingTL.fromTo(col4, {
            y: -1 * window.innerHeight,
            ease: "power4.out",
            duration: 2,
            opacity: 0,
        }, {
            opacity: 1,
            y: 0,
            ease: "power4.out",
            duration: 2,
        },  "<")
        loadingTL.fromTo(col5, {
            y: window.innerHeight,
            ease: "power4.out",
            duration: 2,
            opacity: 0,
        }, {
            opacity: 1,
            y: 0,
            ease: "power4.out",
            duration: 2,
        },  "<")
        loadingTL.fromTo(preloaderTitle, {
            opacity: 0
        }, {
            opacity: 1,
            duration: 0.2
        }, "<+=0.7")
        loadingTL.fromTo('.preloader-title-chars', {
            opacity: 0,    
            duration: 0.2,                 
            ease: "power4.out"      
        }, {
            opacity: 1,
            stagger: 0.08,      
               
        }, ">")
        loadingTL.to(col1, {
            // marginTop: (-1) * window.innerHeight / 2,
            scale: 0.35,
            ease: "power4.out",
            duration: 1.5
        }, ">-=0.3")
        loadingTL.to(col2, {
            // marginTop:  window.innerHeight / 2,
            scale: 0.35,
            transformOrigin: "100% 18%",
            height: "160%",
            justifyContent: "space-between",
            ease: "power4.out",
            duration: 1.5
        }, "<")
        if(window.innerWidth < 768) {
            var gapWidth = '50vh';
        } else { 
            var gapWidth = '25vh';
        }
        loadingTL.to(col3, {            
            scale: 0.4,
            ease: "power4.out",
            gap: gapWidth,
            margin: "-21vh 0",
            justifyContent: "center",
            duration: 1.5
        }, "<")
        loadingTL.to(col4, {
            // marginTop: (-1) * window.innerHeight / 2,
            scale: 0.35,
            transformOrigin: "0% 18%",
            height: "160%",
            justifyContent: "space-between",
            ease: "power4.out",
            duration: 1.5
        }, "<")
        loadingTL.to(col5, {
            // marginTop: window.innerHeight / 2,
            scale: 0.6,
            ease: "power4.out",
            duration: 1.5
        }, "<")
        loadingTL.to(preloader, {
            // scale: 4.5,
            scale: 2,
            ease: "power4.out",
            duration: 1.5
        },"<")
        loadingTL.to(menuLogo, {
            opacity: 1,
            duration: 0.8            
        }, "<")
        loadingTL.to(menuMini, {
            opacity: 1,
            duration: 0.8            
        }, "<")
        // loadingTL.to(menuMenu, {
        //     opacity: 1,
        //     duration: 0.8
        // }, "<")
        loadingTL.to(menuHamburger, {
            opacity: 1,
            duration: 0.8
        }, "<") 
        if(window.innerWidth > 991) {
            var scaleTitle = 2.74
        } else if(window.innerWidth > 768) {
            var scaleTitle = 2
        } else if(window.innerWidth > 575) {
            var scaleTitle = 1.4
        } else {
            var scaleTitle = 1.2
        }
        loadingTL.to(preloaderTitle, {
            scale: scaleTitle,
            ease: "power4.out",
            duration: 1.5
        },"<")   
        loadingTL.to(scrollTag, {
            opacity: 1,
        }, ">")   
        loadingTL.to(scrollLine, {
            
            height: 80
        }, "<")     
        loadingTL.to('body', {
            overflow: 'visible',            
        }, ">")
    

        ScrollTrigger.refresh()
        if(window.innerWidth > 991) {
            var scaleIntro = 1.55
        } else if(window.innerWidth > 768) {
            var scaleIntro = 1.3
        } else if(window.innerWidth > 575) {
            var scaleIntro = 1.1
        } else {
            var scaleIntro = 0.8
        }
        preloaderTL.to(preloaderTitle, {        
            scale: scaleIntro,
            duration: 0.4,
            ease: "power4.out",            
        },">")
        preloaderTL.to(col2, {
            x: window.innerWidth * -0.2,
            ease: "power4.out",
            duration: 1.9
        },  "<")
        preloaderTL.to('[data-target=col-3-go-up]', {
            yPercent: "-200",
            ease: "power4.out",
            duration: 1.9
        },  "<")
        preloaderTL.to('[data-target=col-3-go-down]', {
            yPercent: "200",
            ease: "power4.out",
            duration: 1.9
        },  "<")
        preloaderTL.to(col4, {
            x: window.innerWidth * 0.2,
            ease: "power4.out",
            duration: 1.9
        },  "<")
        preloaderTL.fromTo(title1, {
            top: placeholderTitle2_1.offsetTop,
            left: placeholderTitle2_1.offsetLeft,
        }, {
            left: placeholderTitle1.offsetLeft,
            top: placeholderTitle1.offsetTop,
            duration: 1.3,
        },"<")
        preloaderTL.fromTo(title2, {
            top: placeholderTitle2_2.offsetTop,
            left: placeholderTitle2_2.offsetLeft,
        }, {
            left: placeholderTitle2.offsetLeft,
            top: placeholderTitle2.offsetTop,
            duration: 1.3,
        },"<")
        preloaderTL.fromTo(title3, {
            top: placeholderTitle2_3.offsetTop,
            left: placeholderTitle2_3.offsetLeft,
        }, {
            left: placeholderTitle3.offsetLeft,
            top: placeholderTitle3.offsetTop,
            duration: 1.3,
        },"<")
        preloaderTL.fromTo(title4, {
            top: placeholderTitle2_4.offsetTop,
            left: placeholderTitle2_4.offsetLeft,
        }, {
            left: placeholderTitle4.offsetLeft,
            top: placeholderTitle4.offsetTop,
            duration: 1.3,
        },"<")
        preloaderTL.to(preloaderTitleFillers, {            
            opacity: 1,
            duration: 0.5
        }, ">-=0.7")
        preloaderTL.to(pin, {
            opacity: 0,  
            duration: 0.5   ,
            onStart: video.play()      
        }, ">+=0.2")
        // once(video, "loadedmetadata", () => {
        // preloaderTL.fromTo(
        //   video,
        //   {
        //     currentTime: 0.8
        //   },
        //   {
        //     currentTime: video.duration || 1
        //   }
        // , "<+=0.4")
        
        //   });                
    }
}

export default preloader;